import React, { useContext, useRef, useEffect, useCallback } from "react";
import { Sticky } from "react-sticky";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import AccordionContext from "react-bootstrap/AccordionContext";
export var AccordionToggle = function AccordionToggle(_ref) {
  var children = _ref.children,
      eventKey = _ref.eventKey,
      callback = _ref.callback;
  var currentEventKey = useContext(AccordionContext);
  var decoratedOnClick = useAccordionToggle(eventKey, function () {
    callback && callback(eventKey);
  });
  var isActive = currentEventKey === eventKey;
  return (
    /*#__PURE__*/
    // <Sticky disableCompensation={false} bottomOffset={0}>{
    // ({ style, isSticky }) =>
    // ${(isSticky ? 'is-sticky' : '')}
    React.createElement("button", {
      type: "button" // style={ isActive ? style : {} }
      ,
      className: "\n          cb-button-unstyled\n          cb-accordion__toggle\n          ".concat(isActive ? 'is-active' : '', "\n        "),
      onClick: function onClick() {
        return decoratedOnClick();
      },
      "data-toggle": "collapse",
      "data-target": "#accordion-panel-".concat(eventKey),
      "aria-expanded": isActive,
      "aria-controls": "accordion-panel-".concat(eventKey)
    }, children) // }</Sticky>

  );
};